var map = {
	"./1.jpeg": "7963",
	"./2.jpeg": "5af3",
	"./3.jpeg": "57e9",
	"./4.jpeg": "16f5",
	"./5.jpeg": "8d07",
	"./6.jpeg": "9039",
	"./mk_logo.jpeg": "8640"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3500";